import { useEffect, useState } from 'react'
import { LogAcessoGetAcessosPorPeriodoDoDia } from '../../../../Service/ApiService'
import { Card, CardBody, Col } from 'reactstrap'
import { CardTitle } from '../styles'
import { ApexCharts, LoadingCard, moment, MsgSemRegistros } from '../../../../Components'

let initChart = {
  series: [{ name: 'Acessos', data: [] }],
  options: {
    chart: { type: 'bar', stacked: true, height: 250, toolbar: { show: false } },
    xaxis: { categories: [] },
    responsive: [{ breakpoint: 450, options: { chart: { width: 350 }, legend: { position: 'bottom' } } }],
    plotOptions: { bar: { dataLabels: { total: { enabled: true } } } },
  },
}

const AccessByDayPeriodChart = ({ filters }) => {
  const [confChart, setConfChart] = useState(initChart)
  const [msgId, setMsgId] = useState(1)

  async function loadData() {
    setMsgId(1)
    try {
      const response = await LogAcessoGetAcessosPorPeriodoDoDia(filters)
      if (response?.length > 0) {
        let _confChart = { ...initChart }
        _confChart.series = [
          { name: 'Madrugada', data: response.map((item) => item.qtdeMadrugada) },
          { name: 'Manhã', data: response.map((item) => item.qtdeManha) },
          { name: 'Tarde', data: response.map((item) => item.qtdeTarde) },
          { name: 'Noite', data: response.map((item) => item.qtdeNoite) },
        ]
        _confChart.options.xaxis.categories = response.map((item) => moment(item.dia).format('DD/MMM'))

        setConfChart(_confChart)
        setMsgId(2)
      } else setMsgId(3)
    } catch {
      setMsgId(3)
    }
  }

  useEffect(() => {
    if (filters) loadData()
  }, [filters])

  return (
    <Card className="main-card mb-2">
      <CardBody>
        <CardTitle>Acessos por período do dia</CardTitle>

        {
          {
            1: (
              <Col md="12" className="text-center">
                <LoadingCard isVisible={true} />
              </Col>
            ),
            2: <ApexCharts options={confChart.options} series={confChart.series} type="bar" height={250} />,
            3: <MsgSemRegistros />,
          }[msgId]
        }
      </CardBody>
    </Card>
  )
}

export default AccessByDayPeriodChart
